import { graphql } from '../__generated__/gql';

export const GET_ALL_PROCEDURES = graphql(/* GraphQL */ `
  query Procedure($assetId: Int!) {
    allProcedures(assetId: $assetId) {
      procedureId
      category
      procedureNumber
      title
      url
      status
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);
export const GET_JOB_PROCEDURES = graphql(/* GraphQL */ `
  query JobProcedures($jobId: Int!) {
    proceduresByJobId(jobId: $jobId) {
      procedureId
      category
      procedureNumber
      title
      url
      status
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);
export const CREATE_PROCEDURE = graphql(/* GraphQL */ `
  mutation CreateProcedure($input: ProcedureInput!) {
    createProcedure(input: $input) {
      procedureId
    }
  }
`);

export const UPDATE_PROCEDURE = graphql(/* GraphQL */ `
  mutation UpdateProcedure($input: ProcedureInput!) {
    updateProcedure(input: $input) {
      procedureId
    }
  }
`);

export const LINK_PROCEDURE_JOBS = graphql(/* GraphQL */ `
  mutation LinkProcedureJobs($procedureId: Int!, $jobIds: [Int]!) {
    linkProcedureJobs(procedureId: $procedureId, jobIds: $jobIds) {
      procedureId
    }
  }
`);

export const REMOVE_PROCEDURE = graphql(/* GraphQL */ `
  mutation RemoveProcedure($procedureId: Int!) {
    removeProcedure(procedureId: $procedureId)
  }
`);
